<template>
  <div class="zh-home">
    <div class="show-h5">
      <div class="hm-apply-entry" @click.stop="goToApply">
        <span class="hm-apply-entry__label">申请试用华盟税纪云</span>
        <span class="hm-apply-entry__action">免费试用<a-icon type="right" class="action-icon" /></span>
      </div>
    </div>
    <banner/>
    <!-- <honour/> -->
    <!-- 产品介绍 -->
    <!-- <productIntroduction class="show-pc"/> -->
    <!-- <productIntroductionH5 class="show-h5"/> -->
    <taxDilemma class="show-pc"/>
    <taxDilemmaH5 class="show-h5"/>
    <div class="bg-box show-pc">
      <!-- 解决方案 -->
      <solution/>
      <!-- 数据组件 -->
      <dataComponent class="show-pc"/>
    </div>
    <div class="bg-box-h5 show-h5">
      <!-- 解决方案 -->
      <solution/>
      <!-- 数据组件 -->
      <dataComponentH5 class="show-h5"/>
    </div>
    <!-- 服务咨询 -->
    <!-- <serviceConsultation/> -->
    <!-- todo: 暂时注释 -->
    <!-- 行业解决方案 -->
    <!-- <caseSolution/> -->
    <caseLogo />
    <!-- <newIntroduce/> -->
    <div class="friendship-pc show-pc">
      <div class="title">
        <span @click="friendshipChange('01')" :class="['margin-r-80', { 'friendship-active' : friendshipActive === '01' }]">出海链接</span>
        <span @click="friendshipChange('02')" :class="{ 'friendship-active' : friendshipActive === '02' }">官网链接</span>
      </div>
      <div class="friendship-link" v-if="friendshipActive === '01'">
        <div class="friendship-link-box">
          <div class="friendship-link-item" @click="goFriendshipLink('01')">
            <img src="@/assets/images/e-logo.png" alt="" style="width: 293PX">
            <p>深圳·前海e站通是由深圳市前海深港现代服务业合作区管理局推出的线上线下一体化综合服务平台，全面整合发改、商务、贸促等部门“走出去”职能，提供境外投资备案、技术进出口备案、原产地证签发及国际人才出入境等一站式服务。</p>
          </div>
          <div class="friendship-link-item" @click="goFriendshipLink('02')">
            <img src="@/assets/images/AirTax-logo.png" alt=""  style="width: 249PX">
            <p>AirTax Global 是一个国际税务服务联盟组织，总部注册在新加坡。联盟成员及合作伙伴来自二十多个国家，大多是具有国际四大工作经验的华人，精通中英双语，致力于为中国企业走出去及来华投资者提供财税专业服务。联盟由各成员机构经验丰富的财税专家组成，他们精通国内和国际税收法律法规，提供税务规划、风险评估和合规方面的专业服务。</p>
          </div>
        </div>
      </div>
      <div class="authority" v-if="friendshipActive === '02'">
        <div
          class="authority_logo"
          v-for="item in authorityList"
          :key="item.key"
          @click="toHerf(item.path)"
        >
          <hm-img type="images/about" :imgName="`about_authority_0${item.key}_zh`" imgClass="authority_logo_img" class="friendship_authority_logo"/>
        </div>
      </div>
    </div>
    <div class="friendship-h5 show-h5 introduction_title">
      <span class="text"
          >出海链接
          <div class="title_h5_icon">
            <hm-img
              imgName="home_service_icon_06_h5_zh"
              imgClass="module_img_style"
            />
          </div>
        </span>
      <div class="friendship-link">
        <div class="friendship-link-box">
          <div class="friendship-link-item" @click="goFriendshipLink('01')">
            <img src="@/assets/images/e-logo.png" alt="">
          </div>
          <div class="friendship-link-item" @click="goFriendshipLink('02')">
            <img src="@/assets/images/AirTax-logo.png" alt="" style="width: 100PX" >
          </div>
        </div>
      </div>
    </div>
    <div class="friendship-h5 show-h5 introduction_title" style="margin-top: -20PX">
      <span class="text">官网链接
        <div class="title_h5_icon">
          <hm-img
            imgName="home_service_icon_06_h5_zh"
            imgClass="module_img_style"
          />
        </div>
      </span>
      <div class="authority">
        <template v-for="(item, index) in authorityList">
          <div
            class="authority_logo"
            :key="item.key"
            @click="toHerf(item.path)"
            v-if="index < 6"
          >
            <hm-img type="images/about" :imgName="`about_authority_0${item.key}_zh`" imgClass="authority_logo_img" class="friendship_authority_logo"/>
          </div>
          <div class="authority_logo_1"
            :key="item.key"
            @click="toHerf(item.path)"
            v-else>
            <hm-img type="images/about" :imgName="`about_authority_0${item.key}_zh`" imgClass="authority_logo_img" class="friendship_authority_logo"/>
          </div>
        </template>
      </div>
    </div>
    <tryOut :showLabel="showLabel" :showAgreement="false"/>
    <div class="home_footer show-pc" :style="bannerStyle" v-if="ifShow">
      <div class="footer_title">
        <div class="close" @click.stop="closeAdvert"><hm-img type="images" imgName="home_icon_01_zh" imgClass="footer_icon_style" /></div>
        <!-- <a-button class="downLoad" @click.stop="downLoadClick">点击了解</a-button> -->
      </div>
      <!-- <div class="footer_title">
        <div class="close" @click.stop="closeAdvert"><hm-img type="images" imgName="home_icon_01_zh" imgClass="footer_icon_style" /></div>
        <a-button class="downLoad" @click.stop="downLoadClick">点击了解</a-button>
      </div> -->
    </div>
    <div class="home_footer_h5 show-h5" :style="bannerH5Style" v-if="ifShow">
      <div class="footer_title_h5">
        <div class="close_h5" @click.stop="closeAdvert"><hm-img type="images" imgName="home_service_icon_08_h5_zh" imgClass="footer_icon_h5_style" /></div>
        <div class="downLoad_h5" @click.stop="downLoadClick"><span>点击了解</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from '@/components/banner.vue'
import newIntroduce from './components/newIntroduce'
import caseSolution from './components/caseSolution'
import caseLogo from './components/caseLogo_old'
import productIntroduction from './components/productIntroduction'
import productIntroductionH5 from './components/productIntroduction-h5'
import serviceConsultation from './components/serviceConsultation'
import honour from './components/honour'
import tryOut from '../tryOut'
import taxDilemma from './components/tax-dilemma'
import taxDilemmaH5 from './components/tax-dilemma-h5'
import solution from './components/solution'
import dataComponent from './components/dataComponent'
import dataComponentH5 from './components/dataComponent-h5'
import { authorityList } from './data'
export default {
  name: 'home',
  props: {},
  metaInfo () {
    return this.$route.meta.metaInfo || {}
  },
  components: {
    banner,
    newIntroduce,
    caseSolution,
    caseLogo,
    productIntroduction,
    productIntroductionH5,
    serviceConsultation,
    honour,
    tryOut,
    taxDilemma,
    taxDilemmaH5,
    solution,
    dataComponent,
    dataComponentH5
  },
  data () {
    return {
      friendshipActive: '01',
      bannerStyle: {
        backgroundImage: 'url(' + require('@/assets/images/home_product_00_zh-3.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        backgroundSize: 'auto 100%'
      },
      bannerH5Style: {
        backgroundImage: 'url(' + require('@/assets/images/home_service_images_40_h5_zh.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      },
      authorityList,
      ifShow: true,
      showLabel: ['phoneNo', 'verificationCode', 'enterpriseName']
    }
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {
    closeAdvert () {
      this.ifShow = false
    },
    friendshipChange (activeKey) {
      this.friendshipActive = activeKey
    },
    goFriendshipLink (activeKey) {
      if (activeKey === '01') {
        window.open('https://newtaxera-v3.huamengtech.com/japi3/epp/admin/link?source=HmWebsite&targetUrl=https://www.qhqie.com/')
      } else {
        window.open('https://newtaxera-v3.huamengtech.com/japi3/epp/admin/link?source=HmWebsite&targetUrl=https://airtaxglobal.com/')
      }
    },
    toHerf (path) {
      window.open(path)
    },
    downLoadClick () {
      this.$router.push({
        name: 'cfo'
      })
      // window.open('https://www.huamengtech.com/apply', '_blank')
    },
    goToApply () {
      this.$router.push({ name: 'tryOut' })
    }
  }
}
</script>

<style scoped lang='less'>
#hm-web {
  .bg-box {
    background-image: url(../.././assets/images/sl-banner.png);
    background-position: center;
    background-size: cover;
  }
  .bg-box-h5 {
    background-image: url(../.././assets/images/sl-banner-h5.png);
    background-position: center;
    background-size: cover;
  }
  .zh-home {
    user-select: none;
    // @media screen and (max-width: 1920px) {
    //   .home_footer {
    //     background-image: url(../.././assets/images/home_product_01_zh.png);
    //   }
    // }
    // @media screen and (min-width: 1921px) {
    //   .home_footer {
    //     background-image: url(../.././assets/images/home_product_00_zh.png);
    //   }
    // }
    .home_footer {
      z-index: 9999;
      position: fixed;
      bottom:-3px;
      left:0;
      width: 100vw;
      height: 165PX;
      object-fit: contain;
      .footer_title {
        width: 100%;
        height: 80PX;
        margin: 0 auto;
        margin-top: 100PX;
        // position: relative;
        text-align: center;
        max-width: 1920PX;
        .downLoad {
          width: 118PX;
          height: 36PX;
          background-color: transparent;
          color: #fff;
          // line-height: 36PX;
          // color: #FFFFFF;
          position: absolute;
          top: 83%;
          left: 51vw;
          transform:translateX(120%) translateY(-80%);
          cursor: pointer;
          border: 1PX solid rgba(255,255,255,1);
          &:hover{
          background-color: #ffffff;
          color: #3e77ff;
        }
        }
        .close {
          position: absolute;
          top: 80PX;
          right: 16PX;
          cursor: pointer;
        }
      }
    }
    .home_footer_h5 {
      z-index: 9999;
      position: fixed;
      bottom:0;
      left:0;
      width: 100vw;
      height: 140px;
      object-fit: contain;
      .footer_title_h5 {
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;
        .downLoad_h5 {
          width: 148px;
          height: 60px;
          line-height: 2.8rem;
          border: 2px solid rgba(255,255,255,1);
          border-radius: 40px;
          position: absolute;
          top: 28%;
          left: 75%;
          span {
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            font-weight: 500;
          }
        }
        .close_h5 {
          height: 48px;
          width: 48px;
          position: absolute;
          top: 0%;
          right: 4%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .zh-home {
    padding-top: 72px;
  }
}
</style>
<style lang="less">
#hm-web {
  .footer_icon_style {
    width: 16px;
    height: 16px;
  }
  .footer_icon_h5_style {
    width: 100%;
    height: 100%;
  }
}
.hm-apply-entry {
  position: fixed;
  top: 98px;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 72px;
  line-height: 72px;
  padding: 15px 40px;
  background-image: linear-gradient(180deg, #FFE4B7 0%, #FFF3DF 100%);
  z-index: 2;
  user-select: none;
  cursor: pointer;
  &__label {
    font-size: 28px;
    font-weight: 500;
    color: #292F3A;
  }

  &__action {
    display: block;
    font-size: 26px;
    font-weight: 500;
    color: #995300;
    .action-icon {
      margin-left: 16px;
    }
  }
}

.friendship-pc {
  height: 677PX;
  padding-top: 80PX;
  background-color: #fff;
  .title {
    cursor: pointer;
  }
  .friendship-active{
    color: #176BFF
  }
  .friendship-link{
    width: 1200PX!important;
    height: 420PX;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0PX 1PX 10PX 0PX rgba(216,221,230,0.6);
  }
  .friendship-link-box{
    margin-top: 40PX;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 420PX;
  }
  .friendship-link-item{
    padding: 87PX 55PX;
    height: 420PX;
    text-align: center;
    cursor: pointer;
    width: 600PX;
    &:first-child{
      border-right: 1PX solid #E8EEF8;
      padding: 96PX 55PX;
    }
    p{
      margin-top: 48PX;
      text-align: left;
      font-family: PingFangSC-Regular;
      font-size: 16PX;
      color: #5E5E5E;
      font-weight: 400;
    }
  }
  .title {
    font-size: 40PX;
    font-weight: 600;
    text-align: center;
  }
  .authority {
    width: 1200PX;
    height: 426PX;
    margin:  40PX auto;
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0PX 2PX 5PX #cdd5e5;
    border-radius: 6PX;
    cursor: pointer;
    .authority_logo {
      width: 400PX;
      height: 142PX;
      background-color: #fff;
      border: solid 1PX #f1f5fd;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .authority_logo_img {
      width: auto!important;
      height: 48PX!important;
    }
  }
}
.friendship-h5{
  padding: 0 20PX;
  background: #FFFFFF;
  padding-bottom: 30PX;
  &.introduction_title {
    padding-top: 30PX;
    text-align: center;
    .text {
      font-family: PingFangSC-Medium;
      font-size: 20PX;
      color: #292f3a;
      letter-spacing: 2PX;
      text-align: center;
      line-height: 30PX;
      font-weight: 700;
      padding: 22PX 0 30PX 0;
      position: relative;
      .title_h5_icon {
        width: 32PX;
        height: 32PX;
        position: absolute;
        right: -15%;
        top: -12%;
        transform: translate(50%, 70%);
      }
      .module_img_style{
        width: 16PX!important;
      }
    }
  }
  .friendship-link-box{
    margin-top: 22PX;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0PX 1PX 10PX 0PX rgba(216,221,230,0.6);
  }
  .friendship-link-item{
    padding: 24PX 18PX;
    width: 375PX;
    &:first-child{
      border-right: 1PX solid #E8EEF8;
    }
    img{
      width: 100%
    }
  }
  .authority {
    height: 280PX;
    margin:  40PX auto;
    box-shadow: 0PX 2PX 5PX #cdd5e5;
    border-radius: 6PX;
    cursor: pointer;
    .authority_logo {
      width: 167PX;
      height: 70PX;
      background-color: #fff;
      border: solid 1PX #f1f5fd;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .authority_logo_img {
      width: auto!important;
      height: 22PX!important;
    }
    .authority_logo_1{
      width: 98PX;
      height: 70PX;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .friendship_authority_logo{
        img{
          width: auto!important;
          height: 22PX!important;
        }
      }
    }
  }
}

.margin-r-80{
  margin-right: 80PX;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue